import {Component, Input} from '@angular/core';

@Component({
  selector: 'btx-sub-title-without-link',
  templateUrl: './sub-title-without-link.component.html',
  styleUrls: ['./sub-title-without-link.component.scss'],
  standalone: false
})
export class SubTitleWithoutLinkComponent {

  @Input("title") title?: string;

}
